import angular from 'angular';
import uiRouter from 'angular-ui-router';
import clientAuthorizationsComponent from './clientAuthorizations.component';

let clientAuthorizationsModule = angular.module('clientAuthorizations', [
  uiRouter
])
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('clientAuthorizations', {
      url: '/client-authorizations',
      component: 'clientAuthorizations'
    });
})

.component('clientAuthorizations', clientAuthorizationsComponent)

.name;

export default clientAuthorizationsModule;



// WEBPACK FOOTER //
// ./src/app/pages/clientAuthorizations/clientAuthorizations.js